export const groupViewPropsMixin = {
    props: {
        group: Array,
        name: {
            type: String,
            default: ''
        },
        index: {
            type: Number,
            default: 0
        }
    },
}
